import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';

export function NotFoundPage() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ minHeight: '100vh', textAlign: 'center', p: 3 }}
    >
      <Typography variant="h1" fontWeight={700}>
        404
      </Typography>
      <Typography variant="h6">This page doesn't exist.</Typography>
      <Button component={RouterLink} to={ROUTES.root} variant="contained">
        Back to home
      </Button>
    </Stack>
  );
}
